import {
  SET_PLAYLISTS,
  DELETE_PLAYLIST,
  CLEAR_PLAYLISTS
} from "@/store/mutation-types";

export default {
  [SET_PLAYLISTS](state, playlists) {
    state.playlists = {
      ...state.playlists,
      ...playlists.reduce(
        (map, playlist) => ({ ...map, [playlist.id]: playlist }),
        {}
      )
    };
  },
  [CLEAR_PLAYLISTS](state) {
    state.playlists = null;
  },
  [DELETE_PLAYLIST](state, playlistId) {
    if (state.playlists[playlistId]) {
      delete state.playlists[playlistId];
      state.playlists = { ...state.playlists };
    }
  }
};
